import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const FrontendNavbar = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [click, setClick] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMenu = () => setClick(false);

  useEffect(() => {
    if (!isHome) {
      setScrolled(true); // always colored on other pages
      return;
    }
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  return (
    <header
      className={`fixed left-0 top-0 z-50 h-[90px] w-full transition-colors duration-300 ease-in-out
        ${
          scrolled
            ? "bg-navy-900 text-white shadow-md"
            : "bg-transparent text-white"
        }`}
    >
      <nav className="mx-auto flex h-full max-w-[1240px] items-center justify-between px-4 md:px-8">
        <div className="cursor-pointer select-none text-xl font-bold">
          Makku Logo
        </div>

        {/* Desktop Menu */}
        <ul className="hidden list-none space-x-8 md:flex">
          <li className="border-secondary-color cursor-pointer font-medium hover:border-b-2">
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li className="border-secondary-color cursor-pointer font-medium hover:border-b-2">
            <a href="#about" onClick={closeMenu}>
              About
            </a>
          </li>
          <li className="border-secondary-color cursor-pointer font-medium hover:border-b-2">
            <a href="#contact" onClick={closeMenu}>
              Contact Us
            </a>
          </li>
        </ul>

        {/* Hamburger */}
        <div
          className="z-50 cursor-pointer md:hidden"
          onClick={handleClick}
          aria-label="Toggle menu"
        >
          {click ? <FaTimes size={30} /> : <FaBars size={30} />}
        </div>

        {/* Mobile Menu */}
        <ul
          className={`fixed left-0 top-[90px] flex h-[calc(100vh-90px)] w-full flex-col items-center justify-center space-y-6 bg-black bg-opacity-95 transition-transform
          duration-300 ease-in-out md:hidden
          ${click ? "translate-x-0" : "-translate-x-full"}`}
        >
          <li className="text-xl font-semibold" onClick={closeMenu}>
            <Link to="/">Home</Link>
          </li>
          <li className="text-xl font-semibold" onClick={closeMenu}>
            <a href="#about">About</a>
          </li>
          <li className="text-xl font-semibold" onClick={closeMenu}>
            <a href="#contact">Contact Us</a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default FrontendNavbar;
